import { render, ComponentChild, h } from "preact";

export function renderPage(page: ComponentChild) {
    if (document.body.lastElementChild) {
        render(page, document.body, document.body.lastElementChild);
    } else {
        render(page, document.body);
    }
}
